import firebase from 'firebase/app'
import 'firebase/storage'

export async function uploadImageToFirebase(file) {
  const storageRef = firebase.storage().ref()
  const fileRef = storageRef.child(`library/${Date.now()}-${file.name}`) // Changed to library folder

  await fileRef.put(file)
  return await fileRef.getDownloadURL()
}
